import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThermometerReading, TempDataPoint } from '../version.service';

/**
 * The Klima tab: the room temperatures of the KNX heating rooms (KnxRoomsComponent — tiles, Ist / Soll
 * overview, rooms by floor, room popups "#klima/room/<deviceId>"). The Govee thermometers of the same
 * "thermometers" frames are not shown any more.
 */
@Component({
  selector: 'app-klima',
  templateUrl: './klima.component.html',
})
export class KlimaComponent {
  @Input() thermometers:       ThermometerReading[]                    = [];
  @Input() thermometerHistory: {[deviceId: string]: TempDataPoint[]}  = {};
  @Input() knxFlash            = false;
  @Input() knxUpdatedAt:       number | null                           = null;
  @Input() liveDotOn           = true;
  @Input() nowTick             = Date.now();
  @Input() darkMode            = false;
  /** Admin session headers while the dashboard holds an admin token (the room popups then show their KNX details). */
  @Input() adminAuth: (() => Record<string, string>) | null = null;
  /** The KNX details answered 401: the held token is stale. */
  @Output() adminUnauthorized = new EventEmitter<void>();
}
